// @flow
import React from 'react';
import classNames from 'classnames';
import searchIcon from 'assets/images/search.png';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  value: string,
  placeholder: string,
  className?: string,
  onChange: (value: string) => void,
};

export const SearchInput = ({
  placeholder,
  className = '',
  onChange,
  value = '',
}: Props) => {
  const containerClass = classNames('search-input', className);

  return (
    <div className={containerClass}>
      <input
        value={value}
        placeholder={placeholder}
        onChange={e => onChange(e.target.value)}
      />
      <img src={searchIcon} alt={'icon'} />
    </div>
  );
};
